const EXO_REMOTE_OVERRIDES_SESSION_STORAGE_KEY = "ACS_EXO_REMOTE_OVERRIDES";
const ISSUES_REMOTE_OVERRIDE_KEY = "accIssues";

/**
 * Gets the remote override URL for issues, or null if not set. Reads Web
 * Platform's data from sessionStorage, as they currently don't have an API for
 * this.
 */
export function getIssuesRemoteOverride() {
  try {
    const overrides = readOverridesFromSessionStorage();
    return overrides[ISSUES_REMOTE_OVERRIDE_KEY];
  } catch (e) {
    return undefined;
  }
}

/**
 * Given a URL as string, adds the `accIssues` remote override to it if it
 * exists. This is useful and important for links that open in a new tab, as
 * the remote overrides won't carry over automatically. If the given string is
 * not a valid URL, it will log an error and return the original string.
 */
export function addIssuesRemoteOverrideToUrl(url: string): string {
  const issuesRemoteOverride = getIssuesRemoteOverride();
  if (!issuesRemoteOverride) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set(ISSUES_REMOTE_OVERRIDE_KEY, issuesRemoteOverride);
    return urlObj.toString();
  } catch (e) {
    console.error(
      "Invalid URL provided to addIssuesRemoteOverrideToUrl:",
      url,
      e
    );
    return url;
  }
}

function readOverridesFromSessionStorage(): Record<string, string | undefined> {
  const overridesString = sessionStorage.getItem(
    EXO_REMOTE_OVERRIDES_SESSION_STORAGE_KEY
  );
  if (!overridesString) {
    return {};
  }
  try {
    return JSON.parse(overridesString);
  } catch (e) {
    console.error("Failed to parse overrides from sessionStorage", e);
    return {};
  }
}
